/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { useSelector } from 'react-redux';
import Block from 'wfui-digital-core/es/Block';
import useCustomWFFonts from 'wfui-digital-core/es/useCustomWFFonts';
import { getClasses } from 'wfui-digital-core/es/lib';
import useLanguage from '../../../use-language/use-language';
import styles from './PlatformName.less';
var spanishTranslations = {
  'Wells Fargo Online': 'Banca por Internet',
  'Wells Fargo Business Online': 'Banca por Internet para Empresas'
};

var PlatformName = function PlatformName() {
  var _useLanguage = useLanguage(),
      language = _useLanguage.language;

  var useWFFonts = useCustomWFFonts();
  var platformName = useSelector(function (_ref) {
    var core = _ref.core;
    return core.navigationMenu.platformName;
  });
  var navigationDisabled = useSelector(function (_ref2) {
    var core = _ref2.core;
    return core.navigation.navigationDisabled;
  });
  var classNames = getClasses({
    styles: styles,
    classes: ['platform', useWFFonts && 'useWFFonts']
  });
  return platformName && !navigationDisabled ? /*#__PURE__*/React.createElement(Block, {
    inline: true,
    className: classNames
  }, language === 'sp' && /*#__PURE__*/React.createElement("span", null, spanishTranslations[platformName], " \xA0"), /*#__PURE__*/React.createElement("span", null, platformName, /*#__PURE__*/React.createElement("sup", null, "\xAE"))) : null;
};

export default PlatformName;